












import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

import Navbar from '@/components/Navbar.vue'
import Catalogue from '@/components/Catalogue.vue'
import Cart from '@/components/Cart.vue'
import Sections from '@/components/Sections.vue'

const BaseVue = Vue.extend({
  components: {
    Navbar,
    Catalogue,
    Cart,
    Sections
  },
  computed: {
    ...mapGetters(['currentPage'])
  },
  methods: {
    ...mapActions(['setCurrentPageIndexFromPage'])
  }
})

@Component
export default class Home extends BaseVue {
  configLoaded = false
  shownCart = false
  shownSections = false

  async created () {
    await this.$store.dispatch('loadConfig')
    this.configLoaded = true

    let page = parseInt(this.$route.params.page)

    if (Number.isNaN(page)) {
      page = 1
    }

    setTimeout(() => {
      this.setCurrentPageIndexFromPage(page)
    }, 500)
  }

  @Watch('currentPage')
  onPageChange (page: number) {
    this.$router.replace(`/${page}`)
  }

  showCart () {
    this.shownCart = true
  }

  showSections () {
    this.shownSections = true
  }
}
